module.exports = __webpack_public_path__ + "static/media/hell.79ff1da7.jpg";